import React, { useRef } from "react";
import { GridContainer } from "./styledComponent";
import { DroppableAreaComponent } from "./DroppableAreaComponent";

export default function GridComponent(props) {
    const gridContainerRef = useRef(null);
    const { id, gridItemData, browserName, zoomFactor, idPrefix } =
        props;

    const onLoadData = (imageId) => {
        try {
            // if ((props.isFullScreen === true)) {
                window.totalArr = window.totalArr.filter(e => e !== imageId);
                console.log(window.totalArr, "window.totalArr", imageId)
                // if (window.totalArr.length === 0) {
                //     props.startPlay("workspace")
                // }
            // }
        } catch (error) {
            console.log(error)
        }
    }

    function renderDroppaleAreas() {
        const gridDetails = gridItemData.getIn(["gridData", "gridCells"]);

        let gridCells = [];
        gridDetails.entrySeq().forEach(([key, cellData]) => {
            gridCells.push(
                <DroppableAreaComponent
                    key={key}
                    cellId={key}
                    itemId={id}
                    Id={id}
                    droppableCellData={cellData}
                    gridItemData={gridItemData}
                    gridCellWidth={cellData.get("cellWidth")}
                    gridCellHeight={cellData.get("cellHeight")}
                    browserName={browserName}
                    zoomFactor={zoomFactor}
                    idPrefix={idPrefix}
                    onLoadData={onLoadData}
                />
            );
        });
        return gridCells;
    }

    function gridContainerStyles() {
        return {
            gridTemplateAreas: gridItemData.getIn([
                "gridData",
                "template",
                "areas",
            ]),
            gridTemplateColumns: gridItemData.getIn([
                "gridData",
                "template",
                "columns",
            ]),
            gridTemplateRows: gridItemData.getIn([
                "gridData",
                "template",
                "rows",
            ]),
            gap: gridItemData.getIn(["gridData", "gap"]) * zoomFactor,
        };
    }

    return (
        <GridContainer
            className={`inner-grid-${props.id + 1}`}
            style={gridContainerStyles()}
            ref={gridContainerRef}
        >
            {renderDroppaleAreas()}
        </GridContainer>
    );
}


// WEBPACK FOOTER //
// ./src/components/Grid/GridComponent.js